import { computed, onBeforeUnmount, onMounted, ref, type Ref } from 'vue'

export const VOLKSWAGEN_HEADER_ROOT = '#newIntegratorHeader-vwitg'
export const VOLKSWAGEN_FOOTER_ROOT = '#newIntegratorFooter-vwitg'

export const setVolkswagenIntegratorBoundary = (
  appRoot: HTMLElement | null,
  enabled: boolean
) => {
  if (enabled) {
    appRoot?.setAttribute('data-external-shell', 'volkswagen')
    document.documentElement.setAttribute('data-ocs-external-shell', 'volkswagen')
    document.body.setAttribute('data-ocs-external-shell', 'volkswagen')
    return
  }

  appRoot?.removeAttribute('data-external-shell')
  document.documentElement.removeAttribute('data-ocs-external-shell')
  document.body.removeAttribute('data-ocs-external-shell')
  document.body.removeAttribute('data-vw-integrator-header')
  document.body.removeAttribute('data-vw-integrator-footer')
}

type VolkswagenIntegratorShell = {
  hasFooter: Readonly<Ref<boolean>>
  hasHeader: Readonly<Ref<boolean>>
  isIntegrated: Readonly<Ref<boolean>>
}

export const useVolkswagenIntegratorShell = (
  appRoot: HTMLElement | null,
  enabled: boolean
): VolkswagenIntegratorShell => {
  const hasHeader = ref(false)
  const hasFooter = ref(false)
  const isIntegrated = computed(() => enabled)
  let observer: MutationObserver | undefined

  const syncRemoteRoots = () => {
    hasHeader.value = Boolean(document.querySelector(VOLKSWAGEN_HEADER_ROOT))
    hasFooter.value = Boolean(document.querySelector(VOLKSWAGEN_FOOTER_ROOT))

    if (hasHeader.value) {
      appRoot?.setAttribute('data-vw-integrator-header', 'true')
      document.body.setAttribute('data-vw-integrator-header', 'true')
    } else {
      appRoot?.removeAttribute('data-vw-integrator-header')
      document.body.removeAttribute('data-vw-integrator-header')
    }

    if (hasFooter.value) {
      appRoot?.setAttribute('data-vw-integrator-footer', 'true')
      document.body.setAttribute('data-vw-integrator-footer', 'true')
    } else {
      appRoot?.removeAttribute('data-vw-integrator-footer')
      document.body.removeAttribute('data-vw-integrator-footer')
    }
  }

  const stopObserving = () => {
    observer?.disconnect()
    observer = undefined
  }

  onMounted(() => {
    if (!enabled) return

    syncRemoteRoots()
    observer = new MutationObserver(syncRemoteRoots)
    observer.observe(document.body, { childList: true, subtree: true })
  })

  onBeforeUnmount(() => {
    stopObserving()
    appRoot?.removeAttribute('data-vw-integrator-header')
    appRoot?.removeAttribute('data-vw-integrator-footer')
    document.body.removeAttribute('data-vw-integrator-header')
    document.body.removeAttribute('data-vw-integrator-footer')
  })

  return { hasFooter, hasHeader, isIntegrated }
}